import TargetedCampaign from "../entities/targetedCampaign";

const targetCampaignDataTransformationAfterFetch = (data) => {
  return data.map((row) => {
    return new TargetedCampaign(row);
  });
};

export default targetCampaignDataTransformationAfterFetch;
